import React from "react";
import ChainCard from "@/components/ChainCard";
import { useSettings } from "@/hooks/useSettings";

export default function ChooseChain() {
  const { data } = useSettings();
  const chains = data?.chains || [];
  const supply = data?.tokenomics?.plannedTotalSupply || 1000000000;
  const note = data?.tokenomics?.multiChainNote ||
    "$ROBBED is planned as one unified 1 billion token supply across Solana and Robinhood Chain. The two ecosystems do not represent separate token supplies.";

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
      <span className="tag">Multichain Ready</span>
      <h1 className="headline text-cream text-4xl sm:text-6xl mt-5">$ROBBED IS <span className="text-neon">EVERYWHERE</span></h1>
      <p className="font-heading font-bold uppercase text-dim mt-4 text-base sm:text-lg tracking-wide">
        One community. Multiple chains. Choose your battlefield.
      </p>

      <div className="grid md:grid-cols-2 gap-6 mt-10">
        {chains.map((c) => <ChainCard key={c.chainName} chain={c} />)}
      </div>

      <div className="comic-card p-6 sm:p-8 mt-10 relative overflow-hidden">
        <div className="halftone absolute inset-0 opacity-30" />
        <div className="relative">
          <h3 className="font-display font-900 text-neon text-xl uppercase">Multichain Supply Allocation</h3>
          <p className="font-mono text-sm text-cream/90 mt-3 leading-relaxed">
            Planned total supply is <span className="text-neon font-bold">{supply.toLocaleString()} $ROBBED</span> — this is
            PLANNED, not deployed. {note}
          </p>
          <p className="font-display font-900 text-cream uppercase mt-4 text-sm">
            Final cross-chain amounts and liquidity pairs will be announced before deployment.
          </p>
        </div>
      </div>
    </div>
  );
}
